// extracted by mini-css-extract-plugin
export default {"root":"category-id-field-module_root-O_ooH"};